import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Form from "@sm/core/Form";
import { DATA_TYPES } from "@modules/data/ManualInput";

class UpdateSettlementComponent extends Component {
  state= {
    updateSettlementBaseMidRowFields: [
      {
        name: "name",
        label: "MID",
        disabled: true,
        fieldType: "input",
      },
      {
        name: "date",
        label: "Date",
        disabled: true,
        fieldType: "date",
      },
      {
        name: "balanceToSettle",
        label: "Balance to Settle",
        disabled: true,
        fieldType: "input",
      },
      {
        name: "propertyId",
        label: "Update Status",
        fieldType: "select",
        getOptions: () => this.getFilteredStatuses(this.getOptionsFromState("statuses")),
        items: "statuses",
      },
    ],
    updateSettlementBaseFields: [
      { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" },
      { fieldType: "button" }
    ]
  };

  componentDidMount() {
    const { statuses } = this.props;
    if (statuses) {
      this.setState({
        statuses: statuses,
      });
    }
  }

  componentDidUpdate(oldProps) {
    const newProps = this.props;
    if (oldProps.statuses.length !== newProps.statuses.length) {
      this.setState({
        statuses: newProps.statuses,
      });
    }
  }

  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  onSaveDataEntries = () => {
    const { form } = this.props;

    const isFormValid = form.map((elem) => elem.isFormValid()).every(Boolean);
    this.saveValidationUpdate(form, isFormValid, isFormValid);

    if (isFormValid) {
      const data = form.map((mid) => {
        return {
          propertyId: mid.propertyId,
          date: mid.date,
          id: mid.id,
          name: mid.name,
          midId: mid.midId,
          clientId: mid.clientId,
          balanceToSettle: mid.balanceToSettle,
          runningBalanceAmount: mid.runningBalanceAmount,
        };
      });

      crudActions.put(`v1/data/input/settlements`, data)
        .then(() => {
          this.afterSuccessSave();
        })
        .catch((err) => {
          this.errorUpdate(err ? err.message : '');
        });

    }
  };

  onChangeFilter = () => {
    const { controls } = this.props;

    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);

    if (isFormValid) {
      const { merchant, dataType } = controls;

      const url = `v1/data/input?clientId=${ merchant }&dataInputTypes=${ dataType }
      &midIds=${ controls.midIds }&propertyId=${ controls.settlementStatus }&date=${ controls.updateSettlementDate }`;

      crudActions.get(url)
        .then((response) => {
          const newState =  this.populateUpdateSettlementForm(controls, response);
          Object.assign(newState, {
            showSecondPanel: true,
            loadingDataInput: false,
            lockButton: false,
          });
          this.updateState(newState);
        })
        .catch((err) => {
          this.errorUpdate(err ? err.message : "");
        });
    }
  };

  populateUpdateSettlementForm = (controls, responseMids) => {
    const { updateSettlementBaseMidRowFields, updateSettlementBaseFields } = this.state;
    const stateForUpdate = {};
    const settlementUpdateForm = [];
    const settlementUpdateFields = [];
    responseMids.forEach((elem) => {
      settlementUpdateForm.push(this.getMidRowUpdateSettlementForm(elem));
      settlementUpdateFields.push(updateSettlementBaseMidRowFields);
    });
    settlementUpdateFields.push(updateSettlementBaseFields);
    this.updateField(DATA_TYPES.UPDATE_SETTLEMENT, settlementUpdateFields);
    Object.assign(stateForUpdate, {
      updateSettlementForm: settlementUpdateForm
    });
    return stateForUpdate;
  };

  getMidRowUpdateSettlementForm = (midInfo) => {
    return new Form(
      {
        propertyId: midInfo.propertyId,
        date: midInfo.date,
        id: midInfo.id,
        name: midInfo.name,
        midId: midInfo.midId,
        clientId: midInfo.clientId,
        balanceToSettle: parseFloat(midInfo.balanceToSettle),
        runningBalanceAmount: parseFloat(midInfo.runningBalanceAmount),
      },
      [
        {
          name: "propertyId",
          type: "isNumber",
          rules: {
            required: true,
          }
        },
        {
          name: "date",
          type: "isString",
          rules: {
            required: true,
          },
        },

        {
          name: "id",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "name",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "balanceToSettle",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
      ]
    );
  };

  getFilteredStatuses = (items) => {
    const { savedData } = this.props;
    // id 18 - Settled
    if (savedData.settlementStatus === "18") {
      return items.filter(item => item.label === "Cancelled");
    }
    return items;
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };

  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = () => {
    this.props.updateStateAfterSuccessSave("Operation successful.");
  };

  errorUpdate = (message) => {
    this.props.showErrorAlert(message);
  };

  render() {
    return <></>;
  };
}

export default UpdateSettlementComponent;